export const burnAddresses = [
    "0x0000000000000000000000000000000000000000",
    "0x000000000000000000000000000000000000dead",
];
export const isBurnAddress = (address) => {
    return burnAddresses.includes((address === null || address === void 0 ? void 0 : address.toLowerCase()) || "");
};
